'use client'

import React, { useEffect } from 'react'
import '../../sass/menu/AdSection.scss'

interface AdSenseAdProps {
  adSlot: string
  fullWidthResponsive?: boolean
}

const AD_CLIENT = 'ca-pub-7899330733060299'

// Bloque publicitario de Google AdSense. `adSlot` distingue la unidad de
// anuncio clásica de la moderna; el resto del markup y la carga del script
// son idénticos.
const AdSenseAd: React.FC<AdSenseAdProps> = ({ adSlot, fullWidthResponsive = false }) => {
  useEffect(() => {
    const initializeAds = () => {
      if (typeof window !== 'undefined') {
        const script = document.createElement('script')
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT}`
        script.crossOrigin = 'anonymous'
        script.async = true
        document.body.appendChild(script)

        script.onload = () => {
          try {
            ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({})
          } catch {
            // AdSense push failure is non-critical; do not pollute the console
          }
        }
      }
    }

    initializeAds()
  }, [])

  return (
    <div className='ad-section'>
      <ins
        className='adsbygoogle'
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={adSlot}
        data-ad-format='auto'
        data-full-width-responsive={fullWidthResponsive ? 'true' : 'false'}
      />
    </div>
  )
}

export default AdSenseAd
